<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert" style="text-align:left;"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><img alt="" height="150" src="images/logo-class-200.jpg" width="159"/></p>
<p class="sered"><span class="sm">EDITED</span> <span class="sm">BY</span> Kathryn Lofton <span class="sm">AND</span> John Lardas Modern</p>
<p class="serah" style="font-style: normal;"><span class="sm">BOOKS</span> <span class="sm">IN</span> <span class="sm">THE</span> <span class="sm">SERIES:</span></p>
<p class="seraft"><i>The Lives of Objects: Material Culture, Experience, and the Real in the History of Early Christianity</i></p>
<p class="serau">by Maia Kotrosits</p>
<p class="ser"><i>Make Yourselves Gods: Mormons and the Unfinished Business of American Secularism</i></p>
<p class="serau">by Peter Coviello</p>
<p class="ser"><i>Hunted: Predation and Pentecostalism in Guatemala</i></p>
<p class="serau">by Kevin Lewis O’Neill</p>
<p class="ser"><i>The Aliites: Race and Law in the Religions of Noble Drew Ali</i></p>
<p class="serau">by Spencer Dew</p>
<p class="ser"><i>Faking Liberties: Religious Freedom in American-Occupied Japan</i></p>
<p class="serau">by Jolyon Baraka Thomas</p>
<p class="ser"><i>Credulity: A Cultural History of US Mesmerism</i></p>
<p class="serau">by Emily Ogden</p>
<p class="ser"><i>Consuming Religion</i></p>
<p class="serau">by Kathryn Lofton</p>
<p class="ser"><i>Death Be Not Proud: The Art of Holy Attention</i></p>
<p class="serau">by David Marno</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosson-0003.vue?4149674f